import { config as appConfig } from "../../../app.config"
import { i18n } from "@/plugins/i18n"

const portalSettings = {
  path: "settings",
  component: () => import("@/views/Portal/Settings"),
  meta: {
    pageTitle: i18n.t("route.page_title.portal.settings"),
    rule: "portalAdmin",
  },
  children: [
    {
      path: "",
      name: "portal.settings.general",
      component: () => import("@/views/Portal/PortalSettings/PortalSettingsGeneral"),
      meta: {
        pageTitle: i18n.t("route.page_title.portal.settings"),
        parent: "portal.settings",
        rule: "portalAdmin",
      },
    },
  ],
}

if (appConfig.isZeno || appConfig.isSurferNetwork) {
  portalSettings.children.push({
    path: "account-limits",
    name: "portal.account-limits",
    component: () => import("@/views/Portal/PortalSettings/PortalAccountLimits"),
    meta: {
      pageTitle: i18n.t("route.page_title.portal.account_limits"),
      parent: "portal.settings",
      rule: "portalAdmin",
    },
  })
}

if (appConfig.isZeno) {
  portalSettings.children.push({
    path: "notifications",
    name: "portal.notifications",
    component: () => import("@/views/Portal/PortalNotifications/PortalNotifications.vue"),
    meta: {
      pageTitle: "Notifications",
      parent: "portal.settings",
      rule: "portalAdmin",
    },
  })
}

if (appConfig.isZeno || appConfig.isSurferNetwork) {
  portalSettings.children.push({
    path: "changelog",
    name: "portal.changelog",
    component: () => import("@/views/Portal/PortalChangelog/PortalChangelog"),
    meta: {
      pageTitle: "Changelog",
      parent: "portal.settings",
      rule: "portalAdmin",
    },
  })
}

if (appConfig.isZeno) {
  portalSettings.children.push({
    path: "posts",
    name: "portal.posts",
    component: () => import("@/views/Portal/PortalPosts/PortalPosts"),
    meta: {
      pageTitle: "Posts",
      parent: "portal.settings",
      rule: "portalAdmin",
    },
  })

  portalSettings.children.push({
    path: "posts/create",
    name: "portal.posts.create",
    component: () => import("@/views/Portal/PortalPosts/PortalPostCreate"),
    meta: {
      pageTitle: "Create",
      parent: "portal.posts",
      rule: "portalAdmin",
    },
  })

  portalSettings.children.push({
    path: "posts/:postKey/edit",
    name: "portal.posts.edit",
    component: () => import("@/views/Portal/PortalPosts/PortalPostEdit"),
    meta: {
      pageTitle: "Edit",
      parent: "portal.posts",
      rule: "portalAdmin",
    },
  })
}

if (appConfig.isZeno || appConfig.isSurferNetwork) {
  let children = []
  if (appConfig.isZeno) {
    children.push({
      path: "podcast-ads-settings",
      name: "portal.podcast-ads-settings",
      component: () => import("@/views/Portal/PortalPodcastAdsSettings/PortalPodcastAdsSettings"),
      meta: {
        pageTitle: "Podcast Ads Settings",
        parent: "portal.ads-settings",
        rule: "portalAdmin",
      },
    })
  }

  children.push({
    path: "ads-txt",
    name: "portal.ads-txt",
    component: () => import("@/views/Portal/PortalSettings/PortalAdsTxt.vue"),
    meta: {
      pageTitle: "ads.txt",
      parent: "portal.ads-settings",
      rule: "portalAdmin",
    },
  })

  children.push({
    path: "sellers-json",
    name: "portal.sellers-json",
    component: () => import("@/views/Portal/PortalSettings/PortalSellersJson.vue"),
    meta: {
      pageTitle: "sellers.json",
      parent: "portal.ads-settings",
      rule: "portalAdmin",
    },
  })

  portalSettings.children.push({
    path: "ads-settings",
    name: "portal.ads-settings",
    component: () => import("@/views/Portal/PortalAdsSettings/PortalAdsSettings"),
    meta: {
      pageTitle: "Ads Settings",
      parent: "portal.settings",
      rule: "portalAdmin",
    },
    children: children,
  })
}

export default [portalSettings]
